import { render, staticRenderFns } from "./requisition-detail-form.vue?vue&type=template&id=39ab9390"
import script from "./requisition-detail-form.vue?vue&type=script&lang=js"
export * from "./requisition-detail-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports